<template>
  <div>
    <Head :title="title" />
    <div class="bg-white rounded-md shadow overflow-hidden w-full">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.sn" :error="form.errors.sn" class="pr-6 pb-8 w-full" :label="__('Serial Number')" />

          <select-input v-model="form.type_assets_id" @change="updateCategoryAndBrand" :error="form.errors.type_assets_id" class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Type')" :required="true">
            <option :value="null">{{ __('Select Type') }}</option>
            <option v-for="s in type" :key="s.id" :value="s.id">{{ `${s.name} - ${s.category} - ${s.brand}` }}</option>
          </select-input>

          <text-input v-model="form.category" :error="form.errors.category" class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Category')" disabled />

          <text-input v-model="form.brand" :error="form.errors.brand" class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Brand')" disabled />
        </div>

        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">{{ __('Create Data') }}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

  <script>
import { Head } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'

export default {
  metaInfo: { title: 'Create a New Serial Number' },
  components: {
    LoadingButton,
    TextInput,
    TextareaInput,
    SelectInput,
    Head,
  },
  layout: Layout,
  props: {
    title: String,
    type: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        sn: null,
        type_assets_id: null,
        category: '',
        brand: '',
      }),
    }
  },
  methods: {
    updateCategoryAndBrand() {
      const selectedType = this.type.find((t) => t.id === this.form.type_assets_id)
      if (selectedType) {
        this.form.category = selectedType.category || ''
        this.form.brand = selectedType.brand || ''
      } else {
        this.form.category = ''
        this.form.brand = ''
      }
    },
    store() {
      this.form.post(this.route('asset_serial_number.store'))
    },
  },
}
</script>
